/* eslint-disable react-hooks/exhaustive-deps */
import { QRCodeCanvas } from "qrcode.react";
import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
// import "./CylinderDetail.styles.scss";
import style from "./Cylinders.module.scss";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import CircularLoader from "../../components/Loader/CircularLoader";
import { useDispatch, useSelector } from "react-redux";
import { loadSeries } from "../../redux/admin/actions/admin.actions";
import { Button } from "react-bootstrap";
import { MyButton } from "../../Hooks/useButton";

const Batch = () => {
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const code = localStorage.getItem("batch");

  const { series } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    setLoading(true);
    dispatch(loadSeries(code));
    setLoading(false);
  }, [code, dispatch]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "@page { size: auto; margin: 10mm; } @media print { body { -webkit-print-color-adjust: exact; padding: 40px !important; } }",
  });

  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularLoader />
    </div>
  ) : (
    <div className='main-code'>
      <div
        onClick={() => navigate(-1)}
        className='arrow'
        style={{ cursor: "pointer" }}
      >
        <MdOutlineKeyboardBackspace size={30} /> Back
      </div>
      <div className={style.code_grid} ref={componentRef}>
        {series?.map((o) => (
          <div className={style.code_grid_code}>
            <QRCodeCanvas
              className='cd'
              id='qrCode'
              value={o?.code}
              size={250}
              bgColor={"white"}
              level={"H"}
            />
            <p>{o?.code}</p>
          </div>
        ))}
      </div>

      <div className='batch'>
        <MyButton text='Download' onClick={handlePrint} btnClass='w-100 mt-2' />
      </div>
    </div>
  );
};

export default Batch;
